import { Link, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import { useFormik } from "formik";

const InquiriesDetail = () => {
  const location = useLocation();
  const editData = location.state;
  const initalvalues = {
    fullName: editData?.fullName || "",
    email: editData?.email || "",
    mobileNumber: editData?.mobileNumber || "",
    service: editData?.service || "",
    message: editData?.message || "",
  };

  const { values, handleSubmit } = useFormik({
    initialValues: initalvalues,
    enableReinitialize: true,
  });

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title">View List Inquiry</h3>
        </div>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control form-control-sm `}
                        id="fullName"
                        name="fullName"
                        placeholder="Enter fullName"
                        value={values.fullName}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        className={`border border-dark form-control form-control-sm `}
                        id="email"
                        name="email"
                        placeholder="Enter email"
                        value={values.email}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        Mobile Number
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control form-control-sm `}
                        id="mobileNumber"
                        name="mobileNumber"
                        placeholder="Enter mobile number"
                        value={values.mobileNumber}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-form-label "
                      >
                        Service
                      </label>
                      <input
                        type="text"
                        className={`border border-dark form-control form-control-sm `}
                        id="service"
                        name="service"
                        placeholder="Enter service"
                        value={values.service}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="message" className="col-form-label">
                        Message
                      </label>
                      <textarea
                        className="border border-dark form-control form-control-sm"
                        id="message"
                        name="message"
                        placeholder="Enter message"
                        value={values.message}
                        rows="3"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-4">
                  <Link to="/inquiries">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InquiriesDetail;
